/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

import { transformTextToConfigs } from '../../helpers/text-parser';
import { TextFromConfig, TextFromSimpleConfig } from './components';

import type { ParsedTextConfig } from '../../helpers/text-parser';

export interface ParsedTextProps {
    textOrConfig: string | string[] | ParsedTextConfig[];
}

export const ParsedText: React.FC<ParsedTextProps> = ({ textOrConfig }) => {
    if (typeof textOrConfig === 'string') {
        return <TextFromConfig textConfigs={transformTextToConfigs(textOrConfig)} />;
    } else if (Array.isArray(textOrConfig) && textOrConfig.length > 0 && typeof textOrConfig[0] === 'string') {
        return <TextFromSimpleConfig simpleConfig={textOrConfig as string[]} />;
    } else if (Array.isArray(textOrConfig) && textOrConfig.length > 0) {
        return <TextFromConfig textConfigs={textOrConfig as ParsedTextConfig[]} />;
    }

    console.error('Wrong format for text content');

    return <div />;
};
